import { PageHeaderSection } from '../../components/common/PageHeadSection'
import { t } from 'i18next'
import { RssSourceSelect } from '../../components/tourismNews/RssSourceSelect'
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { TourismNewsService } from '../../services/TourismNewsService';
import { Skeleton, Space } from 'antd';
import { TourismNewsTable } from '../../components/tourismNews/TourismNewsTable';
import { mdlTourismNewsListRequest } from '../../models/service-models/tourismNews/TourismNewsListRequest';
import { RssKeywordFilter } from '../../components/tourismNews/RssKeywordFilter';
import { toast } from 'react-toastify';

export const TourismNews = () => {
    const [rssSourceURL, setRssSourceURL] = useState<string>();
    const [keywords, setKeywords] = useState<string>();

    const handleRssSourceSelection = (sourceURL: string) => {
        setRssSourceURL(sourceURL);
    }

    const handleRssKeywordSearch = (keywords: string) => {
        setKeywords(keywords);
        if (!rssSourceURL) {
            toast.warn(t("tourismNews.pleaseSelectASource"));
        }
    }

    useEffect(() => {
        if (!data && rssSourceURL)
            refetch();
    }, [rssSourceURL, keywords]);

    const {
        data,
        isLoading,
        refetch
    } = useQuery(
        ["getRssFeedData", rssSourceURL, keywords],
        () => {
            if (rssSourceURL) {
                const requestBody: mdlTourismNewsListRequest = {
                    url: rssSourceURL,
                }
                if (keywords && keywords.length > 0) {
                    requestBody.keywords = keywords.split(",")
                }
                return TourismNewsService.List(requestBody);
            }
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!rssSourceURL
        }
    );

    const handleReadMore = (rssFeedDataLink: string) => {
        window.open(rssFeedDataLink, "_blank", "noopener,noreferrer");
    }

    return (
        <>
            <div className="nk-content ">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <PageHeaderSection
                                pageTitle={t("tourismNews.title")}
                            />
                            <div className="nk-block">
                                <div className="row g-gs">
                                    <div className="col-12">
                                        <div className="card card-bordered h-100">
                                            <div className="card-inner">
                                                {
                                                    <>
                                                        <Space size="middle">
                                                            <RssSourceSelect onChange={handleRssSourceSelection} />
                                                            <RssKeywordFilter onSearch={handleRssKeywordSearch} />
                                                        </Space>
                                                    </>
                                                }
                                                {
                                                    isLoading
                                                    &&
                                                    <>
                                                        <Skeleton active />
                                                        <Skeleton active />
                                                        <Skeleton active />
                                                    </>
                                                }
                                                {
                                                    data
                                                    &&
                                                    <TourismNewsTable
                                                        dataSource={data?.body?.data}
                                                        onReadMore={handleReadMore}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
